import { render } from "./ListeMenuPage.vue?vue&type=template&id=64ce11d2&ts=true"
import script from "./ListeMenuPage.vue?vue&type=script&lang=ts"
export * from "./ListeMenuPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__